import { Box } from "@chakra-ui/react";
import { Card } from "@src/components/ui-kit";
import { StatCard } from "@src/components/ui-kit/DataTable/StatCard";
import { Stats } from "@src/components/ui-kit/DataTable/Stats";
import { observer } from "mobx-react-lite";
import type React from "react";
import type { FC } from "react";
import { Body } from "./Body";
import s from "./DataTable.module.css";
import Filter from "./Filter";
import NavBar from "./NavBar";
import SummaryBox from "./SummaryBox";
import SummaryItem from "./SummaryItem";
import { SummaryItemSubText } from "./SummaryItemSubText";

type DataTableProps = {
  bordered?: boolean;
};
const DataTable: FC<React.PropsWithChildren<DataTableProps>> = ({
  bordered = true,
  children,
}) => (
  <Card
    overflowX={{
      base: "scroll",
      md: "unset",
    }}
    maxW={{
      base: "full",
      md: "unset",
    }}
    border={bordered ? undefined : "none"}
  >
    <Box
      w={{
        base: "fit-content",
        md: "full",
      }}
    >
      <Box className={s.DataTable} overflowX="clip">
        {children}
      </Box>
    </Box>
  </Card>
);

const DataTableObservable = observer(DataTable) as FC<
  React.PropsWithChildren<DataTableProps>
> & {
  NavBar: typeof NavBar;
  Filter: typeof Filter;
  SummaryBox: typeof SummaryBox;
  SummaryItem: typeof SummaryItem;
  SummaryItemSubText: typeof SummaryItemSubText;
  Body: typeof Body;
  Stats: typeof Stats;
  StatCard: typeof StatCard;
};

DataTableObservable.NavBar = NavBar;
DataTableObservable.Filter = Filter;
DataTableObservable.SummaryBox = SummaryBox;
DataTableObservable.SummaryItem = SummaryItem;
DataTableObservable.SummaryItemSubText = SummaryItemSubText;
DataTableObservable.Body = Body;
DataTableObservable.Stats = Stats;
DataTableObservable.StatCard = StatCard;

export default DataTableObservable;
